<div class="flex-container_s">
  <div class="img_container" *ngFor="let searchCardData of searchCardDataList">

    <div (click)="OpenItem(searchCardData, 'detail')" class="center_icon_parent">
      <div [ngClass]="searchCardData | searchCard : 'iconbg'">
        <i [ngClass]="searchCardData | searchCard : 'icon'"></i><span class="item_label">
          {{searchCardData | searchCard : 'typename'}}</span>
      </div>
      <img src="{{searchCardData | searchCard : 'image'}}" [title]="searchCardData.ItemName"
        [alt]="searchCardData.ItemName" style="height: 132px; width: 198px; border-bottom:1px solid #cecbcc;">

      
      <div class="section_progress" *ngIf="showProgressBar">
        <div class="slim">
            <div class="progress">
                <div class="progress-bar" role="progressbar" [attr.aria-valuenow]="searchCardData.Progress" aria-valuemin="0" aria-valuemax="100" style="width:100%"  [style.width]="searchCardData.Progress+'%'">
                </div>
              </div>
        </div>
      </div>
      <div class="carousel_caption">
        <div class="wrap_txt">
          {{searchCardData | searchCard : 'itemname'}}
          <!-- {{searchCardData.ItemName}} -->
        </div>
        
        <div *ngIf="searchCardData.ItemTypeCode == 'B'" class="carousel_more" [style.color]="searchCardData.IsFile? '#cf6679':'#03dac5'">
          {{searchCardData | searchCard : 'filecounttext'}}</div>
        <div *ngIf="searchCardData.ItemTypeCode != 'B'" class="carousel_more" [style.color]="searchCardData.IsMandatory? '#cf6679':'#03dac5'">
          {{searchCardData.IsMandatory?"Mandatory":"Optional"}}</div>
      </div>
    </div>
    <a *ngIf="searchCardData.ItemTypeCode == 'B' && searchCardData.IsFile" style="opacity: 0.4;" class="center_play_icon"><i class="center_download_icon"  (click)="OpenItem(searchCardData,'File')"></i></a>
    <a *ngIf="searchCardData.IsFromCatalog && !searchCardData.IsResume" class="center_play_icon"><i class="center_catalog_icon"  (click)="OpenItem(searchCardData,'detail')"></i></a>
    <a *ngIf="searchCardData.IsResume" class="center_play_icon"><i class="center_play_circle"  (click)="OpenItem(searchCardData,'resume')"></i></a>
  </div>
</div>